export const BACKOFFICE_USER_PERMISSION = {
  CUS010101: 'CUS010101',
  CUS010102: 'CUS010102',
  CUS010103: 'CUS010103',
  CUS010104: 'CUS010104',
  CUS010105: 'CUS010105', // สร้างรหัสผ่านชั่วคราว
  MTP010101: 'MTP010101',
  MTP010102: 'MTP010102',
  MTP010103: 'MTP010103',
  MTP010104: 'MTP010104',
  MTP010201: 'MTP010201',
  MTP010202: 'MTP010202',
  MTP010301: 'MTP010301',
  MTP010302: 'MTP010302',
  MTD010101: 'MTD010101',
  MTD020101: 'MTD010101',
  MTT010101: 'MTT010101',
  WEL010101: 'WEL010101',
  WEL010102: 'WEL010102',
  WEL010203: 'WEL010203',
  WEL010204: 'WEL010204',
  POL010101: 'POL010101',
  POL010102: 'POL010102',
  HLT010101: 'HLT010101',
  HLT010102: 'HLT010102',
  HLT010104: 'HLT010104',
  HLT010105: 'HLT010105',
  HLT010106: 'HLT010106',
  HLT010108: 'HLT010108',
  HLT010107: 'HLT010107',
  HLT010109: 'HLT010109',
  HLT010110: 'HLT010110',
  DIS010101: 'DIS010101',
  DIS010102: 'DIS010102',
  DIS010103: 'DIS010103',
  WAT010101: 'WAT010101',
  CAM010101: 'CAM010101',
  CAM010102: 'CAM010102',
  CAM010103: 'CAM010103',
  CAM010104: 'CAM010104',
  HEL010101: 'HEL010101',
  HEL010102: 'HEL010102',
  FAQ010101: 'FAQ010101',
  FAQ010102: 'FAQ010102',
  FAQ010103: 'FAQ010103',
  FAQ010104: 'FAQ010104',
  FAQ010105: 'FAQ010105',
  FAQ010106: 'FAQ010106',
  USR010101: 'USR010101',
  USR010102: 'USR010102',
  WBE010101: 'WBE010101',
  WBE010102: 'WBE010102',
  WBE010103: 'WBE010103',
  WBE010104: 'WBE010104',
  WBE010105: 'WBE010105',
  WBE010106: 'WBE010106',
  WBE010107: 'WBE010107',
  WBE010108: 'WBE010108',
  TA010101: 'TA010101',
  TA010102: 'TA010102',
  TA010103: 'TA010103',
  TA010104: 'TA010104',
  TA010201: 'TA010201',
  TA010202: 'TA010202',
  TA010203: 'TA010203',
  TA010204: 'TA010204',
  TA010205: 'TA010205',
  MTA010101: 'MTA010101',
  MTA010201: 'MTA010201',
  DOP010101: 'DOP010101',
  CLM010101: 'CLM010101', // ดูหน้าเคลมประกันสุขภาพและอุบัติเหตุ
  CLM010102: 'CLM010102', // ดูหน้าเคลมประกันสุขภาพและอุบัติเหตุสำหรับสารบรรณ
  CLM010103: 'CLM010103', // สร้างเคสเคลมประกันสุขภาพและอุบัติเหตุ
  CLM010104: 'CLM010104', // ดูหน้ารายละเอียดการยื่นเคลมประกันสุขภาพและอุบัติเหตุ
  CLM010105: 'CLM010105', // แก้ไขข้อมูลรายละเอียดการยื่นเคลมประกันสุขภาพและอุบัติเหตุ
  CLM010106: 'CLM010106', // กดปุ่มรับเอกสารฉบับจริง
  CLM010107: 'CLM010107', // เปลี่ยนเจ้าของเคสเคลมประกันสุขภาพและอุบัติเหตุ
  CLM010108: 'CLM010108', // ยกเลิกเคสเคลมประกันสุขภาพและอุบัติเหตุ
  ASS010101: 'ASS010101', // ดูตารางการ Auto assign งานสินไหมสุขภาพ
  ASS010102: 'ASS010102', // การจัดการ Auto assign งานเคลม เพิ่มพนักงาน
  ASS010103: 'ASS010103', // การจัดการ Auto assign งานเคลม ลบพนักงาน
  APP010101: 'APP010101', // การจัดการผู้อนุมัติ ดูรายการผู้อนุมัติ
  APP010102: 'APP010102', // การจัดการการอนุมัติ เพิ่มผู้อนุมัติ
  APP010103: 'APP010103', // การจัดการการอนุมัติ แก้ไขผู้อนุมัติ ลบผู้อนุมัติ
  APP010104: 'APP010104', // การจัดการการอนุมัติ สิทธิ์การอนุมัติ
  APP010201: 'APP010201', // การจัดการการอนุมัติวงเงิน ดูตารางการจัดการวงเงิน
  APP010202: 'APP010202', // การจัดการการอนุมัติวงเงิน เพิ่มระดับอนุมัติวงเงิน
  APP010203: 'APP010203', // การจัดการการอนุมัติวงเงิน แก้ไขระดับอนุมัติวงเงิน
  APP010204: 'APP010204', // การจัดการการอนุุมัติวงเงิน ลบระดับอนุมัติวงเงิน
  CRS010101: 'CRS010101', // ดูหน้ารายละเอียดตรวจจับการชน
  CRS010102: 'CRS010102', // แก้ไขข้อมูลรายละเอียดตรวจจับการชน
}
export const DEFAULT_BACKOFFICE_USER_PERMISSIONS = Object.values(BACKOFFICE_USER_PERMISSION)

export const BACKOFFICE_USER_MENU = {
  CUS01: 'CUS01',
  MTP01: 'MTP01',
  WEL01: 'WEL01',
  POL01: 'POL01',
  DIS01: 'DIS01',
  WAT01: 'WAT01',
  CAM01: 'CAM01',
  HEL01: 'HEL01',
  FAQ01: 'FAQ01',
  USR01: 'USR01',
  MTD01: 'MTD01',
  MTD02: 'MTD02',
  MTT01: 'MTT01',
  WBE01: 'WBE01',
  TA01: 'TA01',
  MTA01: 'MTA01',
  DOP01: 'DOP01',
  CLM01: 'CLM01', // รายการเคลมประกันสุขภาพและอุบัตเหตุ
  AAS01: 'AAS01', // การจัดการ Auto assign งานเคลม
  APP01: 'APP01', // การจัดการระดับการอนุมัติการเคลม
  CRS01: 'CRS01', // รายการตรวจจับการชน
}

export const DEFAULT_BACKOFFICE_USER_MENUS = Object.values(BACKOFFICE_USER_MENU)

export const BACKOFFICE_USER_PAGE = {
  MTP0101: 'MTP0101',
  MTP0102: 'MTP0102',
  MTP0103: 'MTP0103',
  MTD0101: 'MTD0101',
  MTD0201: 'MTD0201',
  MTT0101: 'MTT0101',
  WEL0101: 'WEL0101',
  POL0101: 'POL0101',
  HLT0101: 'HLT0101',
  DIS0101: 'DIS0101',
  WAT0101: 'WAT0101',
  CAM0101: 'CAM0101',
  HEL0101: 'HEL0101',
  FAQ0101: 'FAQ0101',
  USR0101: 'USR0101',
  CUS0101: 'CUS0101',
  WBE0101: 'WBE0101',
  TA0101: 'TA0101',
  TA0102: 'TA0102',
  MTA0101: 'MTA0101',
  DOP0101: 'DOP0101',
  CLM0101: 'CLM0101', // การทำรายการเคลมประกันสุขภาพและอุบัตเหตุ
  AAS0101: 'AAS0101', // การทำรายการ Auto assign งานเคลม
  APP0101: 'APP0101', // การจัดการผู้อนุมัติ
  APP0102: 'APP0102', // การจัดการการอนุมัติวงเงิน
  CRS0101: 'CRS0101', // การทำรายการตรวจจับการชน
}

export const DEFAULT_BACKOFFICE_USER_PAGES = Object.values(BACKOFFICE_USER_PAGE)

export const BACKOFFICE_USER_MENU_TYPE = {
  'ข้อมูลลูกค้าทั่วไป': 'ข้อมูลลูกค้าทั่วไป',
  'ประกันรถยนต์': 'ประกันรถยนต์',
  'ประกันสุขภาพ': 'ประกันสุขภาพ',
  'การจัดการระบบ': 'การจัดการระบบ',
  'ประกันเดินทาง': 'ประกันเดินทาง',
}

export const DEFAULT_BACKOFFICE_USER_MENU_TYPES = Object.values(BACKOFFICE_USER_MENU_TYPE)
